import stringDateTemplate from "@utils/stringDateTemplate"
import iosSupportVh from "@utils/iosSupportVh"
import guardRapidClick from "@utils/guardRapidClick"
import createAnimate from "@utils/createAnimate"
import getJapaneseYear from "@utils/getJapaneseYear"
import * as commonUtil from "@utils/commonUtil"

export {
  stringDateTemplate,
  iosSupportVh,
  guardRapidClick,
  createAnimate,
  getJapaneseYear,
  commonUtil
}